import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import Modal from '../Modal';
import styles from './EditApprovalsCommentModal.module.scss';

const EditApprovalsCommentModal = ({ initialComment, handleEditComment, isShow, onClose }) => {
  const [comment, setComment] = useState({ id: initialComment.id, content: initialComment.content });
  const inputRef = useRef(null);

  const handleInputChange = event => {
    setComment({ ...comment, content: event.target.value });
  };
  const { t } = useTranslation();

  const handleFocus = () => {
    const commentLength = comment.content?.length;
    inputRef.current.setSelectionRange(commentLength, commentLength);
  };

  const handleEdit = () => {
    handleEditComment(comment);
    onClose();
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t('approvals.comment.edit_modal_header')}</span>
          <Icon src="close" className={styles.closeIcon} onClick={onClose} />
        </div>
        <div className={styles.text}>
          <textarea
            ref={inputRef}
            className={styles.comment}
            placeholder={t('approvals.comment.placeholder')}
            value={comment.content}
            onChange={handleInputChange}
            onFocus={handleFocus}
          />
        </div>
        <div className={styles.buttonsContainer}>
          <CustomButton variant="secondary" label={t('general.cancel')} onClick={onClose} />
          <CustomButton
            className={styles.editBtn}
            variant="primary"
            disabled={comment.content === initialComment.content || comment.content?.trim() === ''}
            label={t('general.edit')}
            onClick={handleEdit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EditApprovalsCommentModal;
